import styled from 'styled-components';
import tw from 'tailwind-styled-components';

export const Wrapper = styled.div`
  .accordion__item {
    border-top: 1px solid #010E54;
  }
  > div {
    border-bottom: 1px solid #010E54;
  }
  .accordion__button:focus,
  .accordion__button:focus-visible {
    outline: none;
  }
`;

export const ImageContainer = tw.div`
  relative
`;

export const Image = tw.img`
  w-full
  h-full
  object-fit
`;

export const AccordianBodyContainerTW = tw.div`
  ml-0
  my-5
  md:mt-0
  md:mb-50
`;

export const AccordianBodyContainer = styled(AccordianBodyContainerTW)<{ $isReverse: boolean }>`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  @media (max-width: 767px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const StyledImage = styled.div`
  width: 49.23%;
  @media (max-width: 767px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;
export const StyledText = styled.div<{ $isReverse: boolean }>`
  width: 49.23%;
  @media (max-width: 767px) {
    width: 100%;
  }
`;
